import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import { pxToVw } from '@/modules/styled/cssUnits';
import styled from 'styled-components';

export const StyledLibraryActivitiesList = styled.div`
  .header {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: ${pxToVw(60)} !important;

    .first-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
    }

    .second-row {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: ${pxToVw(30)};
    }
  }

  .activities {
    display: grid;
    grid-template-columns: repeat(auto-fill, 200px);
    justify-content: space-around;
    grid-gap: 60px;
    margin-bottom: 100px;
  }

  .empty {
    margin-bottom: 60px;
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    .header {
      .title {
        gap: 10px;
        margin-top: ${pxToVw(64)};
        margin-bottom: 20px;
      }

      .first-row {
        align-items: flex-start;
      }

      .second-row {
        flex-direction: column;
        gap: 40px;
      }
    }
  }
`;
